import React, { useState } from 'react'
import uuidv4 from 'uuid/v4'

import { axios } from 'api'
import { useStripeCheckout } from 'context'
import { Button } from 'ui/bend'
import { useActiveMembershipContext } from '../../../ActiveMembershipStore'
import { useGetCountry } from 'hooks'

const idempotencyKey = uuidv4()

const SubmitButton = () => {
  const getStripe = useStripeCheckout()
  const { plan } = useActiveMembershipContext()

  const [loading, setLoading] = useState(false)
  const country = useGetCountry(false)

  const handleClick = async () => {
    setLoading(true)
    const stripe = await getStripe()
    try {
      const { data } = await axios.post('users/me/membership/stripe', {
        idempotency_key: idempotencyKey,
        plan: plan.id,
        checkout: true,
        cancel_path: window.location.pathname,
        country
      })

      stripe.redirectToCheckout({
        sessionId: data.checkoutSessionId
      })
    } catch (e) {
      console.error(e)
      setLoading(false)
      // TODO: handle error from POST request
    }
  }

  return (
    <Button
      onClick={handleClick}
      processing={loading}
      alignSelf={['stretch', 'flex-end']}
      mt={['16px', '24px']}
    >
      Change Payment Method
    </Button>
  )
}

export default SubmitButton
